import { Check } from "lucide-react";
import { SERVICES } from "../../lib/site";

export const Services = () => {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="py-24 md:py-32 max-w-7xl mx-auto px-6 lg:px-8"
    >
      <div className="max-w-4xl mb-12">
        <p
          data-testid="services-intro"
          className="font-display text-2xl sm:text-3xl tracking-tight text-brand-ink/85 leading-snug"
        >
          <span className="text-brand-eucalyptus font-bold">Empower Legacy Finance</span>{" "}
          helps Australians find the right loan — from first homes to
          investment portfolios. We compare 40+ lenders, do the heavy lifting,
          and stay with you for life.
        </p>
      </div>

      <div className="grid lg:grid-cols-12 gap-10 mb-14">
        <div className="lg:col-span-5">
          <div className="label-eyebrow text-brand-terracotta mb-5">
            What we do
          </div>
          <h2 className="font-display text-4xl sm:text-5xl tracking-tight font-medium text-brand-ink">
            Loans for every chapter of your life.
          </h2>
        </div>
        <div className="lg:col-span-6 lg:col-start-7 flex items-end">
          <p className="text-base md:text-lg text-brand-ink/70 leading-relaxed">
            Whether you&apos;re buying your first home, scaling an investment
            portfolio or refinancing for a sharper rate — we&apos;ll structure
            it properly and explain everything in plain English.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {SERVICES.map((s) => (
          <article
            key={s.key}
            data-testid={`service-card-${s.key}`}
            className="group relative overflow-hidden rounded-2xl border border-border bg-card p-6 lg:p-8 flex flex-col justify-between min-h-[340px] transition-all duration-300 hover:-translate-y-1 hover:shadow-md"
          >
            {s.image && (
              <div className="absolute inset-0">
                <img
                  src={s.image}
                  alt=""
                  aria-hidden
                  className="w-full h-full object-cover opacity-80 group-hover:opacity-100 transition-opacity"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-brand-terracotta/95 via-brand-terracotta/65 to-brand-terracotta/30" />
              </div>
            )}
            <div className={`relative ${s.image ? "text-brand-cream" : "text-brand-ink"}`}>
              <h3 className="font-display text-2xl sm:text-3xl tracking-tight">
                {s.title}
              </h3>
              <p className={`mt-3 text-sm md:text-base ${s.image ? "text-brand-cream/85" : "text-brand-ink/70"} leading-relaxed max-w-md`}>
                {s.blurb}
              </p>
            </div>
            <ul className={`relative mt-6 space-y-2 ${s.image ? "text-brand-cream/90" : "text-brand-ink/80"}`}>
              {s.bullets.map((b) => (
                <li key={b} className="flex items-start gap-2 text-sm">
                  <Check
                    className={`h-4 w-4 mt-0.5 ${s.image ? "text-brand-cream" : "text-brand-eucalyptus"}`}
                    strokeWidth={1.8}
                  />
                  {b}
                </li>
              ))}
            </ul>
          </article>
        ))}
      </div>
    </section>
  );
};
